import {Input} from "antd";
import {useLocation, useNavigate, useOutletContext} from "react-router";
import CustomButton from "../../general/CustomButton";

const SecondStep = ({question}) => {

    const {info, setInfo} = useOutletContext()
    const navigate = useNavigate()
    const location = useLocation()

    const changeInfoHandler = (e) => {
        setInfo({...info, email: e.target.value})
    }

    const keyPressHandler = (e) => {
        if (e.key === "Enter" && e.target.value) {
            // setInfo({...info, name: e.target.value})
            if (location.pathname.includes('partner')) {
                navigate('/questions/partner/3')
            } else {
                navigate('/questions/3')
            }
        }
    }

    const nextPageHandler = () => {
        if (info.email) {
            if (location.pathname.includes('partner')) {
                navigate('/questions/partner/3')
            } else {
                navigate('/questions/3')
            }
        }
    }

    const prevPageHandler = ()=>{
        if (location.pathname.includes('partner')) {
            navigate('/questions/partner/1')
        } else {
            navigate('/questions/1')
        }
    }

    return (
        <div>
            <div>{question}</div>
            <Input placeholder={'ایمیل خود را وارد کنید'} name={'email'} size={'large'} value={info.email}
                   onKeyPress={keyPressHandler}
                   onChange={changeInfoHandler}
            />
            <div style={{width: '100%',display:'flex',alignItems:'center',justifyContent:'space-between',marginTop:'1rem'}}>
                <CustomButton
                    text={'مرحله بعد'}
                    width={150}
                    style={{marginTop: '1rem',backgroundColor:`${info.name ? '#32B8C5':'#ADF2F8'}`}}
                    onClick={nextPageHandler}
                />
                <CustomButton
                    text={'مرحله قبل'}
                    ghost={true}
                    width={150}
                    style={{marginTop: '1rem'}}
                    onClick={prevPageHandler}
                />
            </div>
        </div>
    )
}

export default SecondStep